import { render, staticRenderFns } from "./AddEditQuestion.vue?vue&type=template&id=607df8ad&scoped=true"
import script from "./AddEditQuestion.vue?vue&type=script&lang=js"
export * from "./AddEditQuestion.vue?vue&type=script&lang=js"
import style0 from "./AddEditQuestion.vue?vue&type=style&index=0&id=607df8ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607df8ad",
  null
  
)

export default component.exports